import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Navbar() {
  const navigate = useNavigate();

  return (
    <nav>
      <div className="nav-inner">
        <div className="nav-brand" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <div className="nav-logo">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
          </div>
          <span className="nav-name">SafeSnap</span>
          <span className="badge badge-accent" style={{ marginLeft: 8 }}>BETA</span>
        </div>

        <div className="nav-links">
          <span className="nav-link" onClick={() => navigate('/')}>Home</span>
          <span className="nav-link" onClick={() => navigate('/verify')}>Verify a photo</span>
          <a
            href="https://play.google.com/store/apps/details?id=com.safesnap.app"
            target="_blank"
            rel="noreferrer">
            <button className="nav-btn">Download app</button>
          </a>
        </div>
      </div>
    </nav>
  );
}
